import React from 'react';
import { motion } from 'framer-motion';
import { FaLinkedinIn } from 'react-icons/fa';
import { useLanguage } from '../LanguageContext';
import SEO from '../components/SEO';
import './About.css';

const About = () => {
  const { t } = useLanguage();

  return (
    <div className="about-page">
      <SEO 
        title={t('about.seoTitle')}
        description={t('about.seoDescription')}
        keywords="about future money, asset management company, Ljubljana Slovenia, EU regulated, crypto fund management, virtual currency services"
      />
      
      {/* Company Profile Section */}
      <section className="company-profile-section section">
        <div className="container">
          <div className="company-profile-grid">
            <motion.div
              className="company-intro"
              initial={{ opacity: 0, x: -30 }}
              whileInView={{ opacity: 1, x: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.6 }}
            >
              <h1 className="company-name">
                {t('about.companyName')}
              </h1>
              <p className="company-tagline">{t('about.tagline1')}</p>
              <p className="company-tagline">{t('about.tagline2')}</p>
              <p className="company-tagline">{t('about.tagline3')}</p>
            </motion.div>

            <motion.div
              className="company-details"
              initial={{ opacity: 0, x: 30 }}
              whileInView={{ opacity: 1, x: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.6 }}
            >
              <h2 className="profile-title">{t('about.profileTitle')}</h2>
              
              <p>
                {t('about.profileText1')}
              </p>
              
              <p>
                {t('about.profileAddress')}
              </p>
              
              <p>
                {t('about.profileText2')} <a href="https://www.a-tvp.si/eng" target="_blank" rel="noopener noreferrer">https://www.a-tvp.si/eng</a>, <a href="https://www.a-tvp.si/eng/lists-of-issued-licences-/aifm-registered-not-supervised" target="_blank" rel="noopener noreferrer">https://www.a-tvp.si/eng/lists-of-issued-licences-/aifm-registered-not-supervised</a>)
              </p>
              
              <p>
                {t('about.profileText3')}
              </p>
              
              <div className="company-identifiers">
                <p>{t('about.identificationNumber')}: 8557012000</p>
                <p>{t('about.taxNumber')}: 56003609</p>
                <p>{t('about.lei')}: 950400U7J4DUDR9TNC52</p>
              </div>
            </motion.div>
          </div>
        </div>
      </section>

      {/* Meet the Team Section */}
      <section className="team-section section">
        <div className="container">
          <motion.div
            className="team-header"
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.6 }}
          >
            <h2 className="team-title">{t('about.teamTitle')}</h2>
            <p className="team-description">
              {t('about.teamDescription')}
            </p>
          </motion.div>

          <div className="team-grid">
            <motion.div
              className="team-member-card"
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.5 }}
            >
              <div className="member-image-container">
                <img src="/Katjaflip.avif" alt="MSc. Katja Damij" className="member-image" />
              </div>
              <div className="member-info">
                <span className="member-role">{t('about.directorRole')}</span>
                <h3 className="member-name">MSc. Katja Damij</h3>
                <p className="member-bio">
                  {t('about.directorBio')}
                </p>
                <a 
                  href="https://www.linkedin.com/in/katjadamij/" 
                  target="_blank" 
                  rel="noopener noreferrer"
                  className="linkedin-link"
                  aria-label="LinkedIn profile of Katja Damij"
                >
                  <FaLinkedinIn />
                </a>
              </div>
            </motion.div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default About;
